import base from './classes'
import { cloneDeep } from 'lodash'

const derived = cloneDeep(base)

derived.getters.columns = (state, getters, rootState) => {
  const cols = base.getters.columns(state, getters, rootState)
  cols.forEach(col => {
    col.hideWhenDisplaying = !([
      'row_menu',
      'id',
      'native_id',
      'location_id',
      'start_date',
      'start_time',
      'classpass_com_displayed_regular_availability_cap',
      'classpass_com_displayed_regular_availability_bookings',
      'available_spots_on_studio_cp_site',
      'broker_availability_per_rules_and_overrides',
      'broker_availability_remaining_spots'
    ].includes(col.name))
  })

  return cols
}

export default derived
